/* eslint-disable */
import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
import Button from '@material-ui/core/Button';
import {FacebookLoginButton,GoogleLoginButton,TwitterLoginButton} from "react-social-login-buttons"
import {Cookies, withCookies} from "react-cookie";
import { instanceOf } from 'prop-types';
import SuccessMessage from '../../components/AlertMessages/SuccessMsg';
import AuthService from '../../Services/AuthService';


const styles = theme => ({
  button: {
    margin: theme.spacing.unit,
  },
  input: {
    display: 'none',
  },
});


class Login extends Component {
  
constructor(props){
  super(props);
  this.state={ 
    username:'', 
    password:'',
  }
  this.handleChange = this.handleChange.bind(this);
  this.handleSubmit = this.handleSubmit.bind(this);
  this.Auth = new AuthService();
  }

  handleChange = async event =>{
    this.setState({ [event.target.name]:event.target.value })
  }

  componentWillMount(){
    if(this.Auth.loggedIn())
        this.props.history.replace('/');
  }

handleSubmit = async event =>{
  event.preventDefault();
  console.log("User name : " + this.state.username)
  console.log("User Password : " + this.state.password)
  localStorage.setItem('username', this.state.username)
  this.Auth.login(this.state.username,this.state.password)
    .then(res =>{
        this.props.history.replace('/');
        window.location.reload();
    })
    .catch(err =>{
        console.log(err);
        alert(err);
    })
    
  }

render(){
if(this.state.msgSuccess) return <p><SuccessMessage /></p>
return(
   <div style={{
            padding: '15px 50px 75px',
            width: '350px',
            margin: 'auto',
          }}>
    <div>
        <MuiThemeProvider>
        <h2>SIGNIN TO CONNECT</h2>
          <form onSubmit={this.handleSubmit}>
            <div>
             <TextField
               hintText="Enter your Username"
               floatingLabelText="Username"
               onChange = {(event,newValue) => this.setState({username:newValue})}
               />
             <br/>
               <TextField
                 type="password"
                 hintText="Enter your Password"
                 floatingLabelText="Password"
                 onChange = {(event,newValue) => this.setState({password:newValue})}
                 />
               <br/>
               <h3>
                <Button
                  type="submit"
                  variant="raised"
                  fullWidth
                  color="primary">
                  Signin
                </Button>
                </h3>
                <h3>
                 <FacebookLoginButton onClick={() => alert("Hello")}/>
                </h3>
                <h3>
                <GoogleLoginButton onClick={() => alert("Hello")}/>
                </h3>
                 <p>Not Registered yet?<a href="/signup"> Signup here</a></p>
            </div>
          </form>
         </MuiThemeProvider>
      </div>

  </div>
  )
  }

}

const style = {
 margin: 15,
};

export default withCookies(Login);


// WEBPACK FOOTER //
// ./src/components/Signin/Login.js